/** StakeWise V3 vault — minimal ABI for `calculateExitedAssets`
 *  finalization re-check after subgraph query.
 *
 *  The subgraph returns `isClaimable` based on its last-indexed block,
 *  which can lag a few blocks. For correctness we re-confirm against
 *  the vault contract; for `claimable`-status reporting we use the
 *  on-chain answer. */
export const StakeWiseV3VaultAbi = [
  {
    name: 'calculateExitedAssets',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'receiver' },
      { type: 'uint256', name: 'positionTicket' },
      { type: 'uint256', name: 'timestamp' },
      { type: 'uint256', name: 'exitQueueIndex' },
    ],
    outputs: [
      { type: 'uint256', name: 'leftShares' },
      { type: 'uint256', name: 'claimedShares' },
      { type: 'uint256', name: 'claimedAssets' },
    ],
  },
  {
    name: 'getExitQueueIndex',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'positionTicket' }],
    outputs: [{ type: 'int256' }],
  },
] as const
